<template>
  <nav>
    <div v-for="(item,inx) in navList" :key="inx" class="nav-item">
      <div :class="['nav-quan',{'red':index===inx,'black':index>inx}]">
        <img src="../images/img_gou@2x.png" v-if="index>inx"/>
        <span v-else>{{item.number}}</span>
      </div>
      <div :class="['nav-title']">{{item.content}}</div>
      <div class="left" v-if="inx!==navList.length-1"></div>
    </div>
  </nav>
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      navList: [
        { number: 1, content: '还款信息确认' },
        { number: 2, content: '展期订单申请' },
        { number: 3, content: '申请结果确认' }
      ]
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../../assets/less/mixin.less";

nav{
        width: 690px;
        height: 190px;
        background: #F1F1F1;
        border-radius: 20px;
        padding: 42px 40px 36px 64px;
        display: flex;
        align-items: center;
        justify-content:space-between;
        margin:30px auto 0;
        .nav-item{
            flex:1;
            display: flex;
            flex-direction:column;
            align-items:center;
            position: relative;
            .left{
                position: absolute;
                background:url('../images/img_1@2x.png');
                width:24px;
                height:21px;
                left:188px;
                top:20px;
                background-size:100% 100%;
            }
            .nav-quan{
                width: 54px;
                height: 54px;
                border: 3px solid #CCCCCC;
                color: #CCCCCC;
                border-radius:50%;
                display: flex;
                align-items: center;
                justify-content:center;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                >img{
                    width:25px;
                    height:18px;
                }
            }
            .red{
                color:#FF4633;
                border: 3px solid #000000;
            }
            .black{
                border: 3px solid #000000;
            }
            .nav-title{
                height: 33px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 33px;
                margin-top:25px;
            }
        }
    }
</style>